import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree} from '@angular/router';
import { UserService } from '../user/user.service';

@Injectable({
    providedIn: 'root'
})
export class AuthGuard implements CanActivate {

    constructor(private userService: UserService, private router: Router) {
    }

    async canActivate(
        next: ActivatedRouteSnapshot,
        state: RouterStateSnapshot): Promise<boolean | UrlTree> {
        // Check session timeout before allowing navigation
        if (this.userService.isSessionExpired()) {
            // Persist target so we can honor it after the full page reload
            // performed by checkSessionTimeout -> window.location.replace.
            try {
                sessionStorage.setItem('medpal_return_url', state.url);
            } catch {
                /* ignore storage failures */
            }
            await this.userService.checkSessionTimeout();
            return false;
        }

        if (this.userService.isUserLoggedIn()) {
            return true;
        }

        return this.router.createUrlTree(['/user/login'], {
            queryParams: { returnUrl: state.url }
        });
    }
}
